/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ variant: NonNullable<unknown> }} Property_Ai_Draft_ReadyInputs */

const cs_property_ai_draft_ready = /** @type {(inputs: Property_Ai_Draft_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nový návrh je hotový (${i?.variant})`)
};

const en_property_ai_draft_ready = /** @type {(inputs: Property_Ai_Draft_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`New ${i?.variant} draft is ready`)
};

/**
* | output |
* | --- |
* | "New {variant} draft is ready" |
*
* @param {Property_Ai_Draft_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_draft_ready = /** @type {((inputs: Property_Ai_Draft_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Draft_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_draft_ready(inputs)
	return cs_property_ai_draft_ready(inputs)
});